module.exports = __webpack_public_path__ + "static/img/icon-national.d56ebd7c.png";